import { CustomerMasterSourceType } from 'generated/bffFinancialInfo/models';
import { ExtendedAxiosResponse, apiClient } from 'helpers/apiClient';
import { ChannelType } from 'models/ChannelType';

export const api = {
  getBillingPartyList: (url: string, cpRefNo?: string): Promise<ExtendedAxiosResponse> =>
    apiClient.get(`${url}/billing-party/list`, {
      params: {
        customerMasterSource: CustomerMasterSourceType.O2POP,
        channel: ChannelType.MO2_CARE,
        forceCheck: false,
        cpRefNo,
      },
    }),

  postEBillFileDownloadInfo: (
    url: string,
    billMonth?: number,
    billYear?: number,
    caRefNoList?: string[],
    contextCpRefNo?: string,
    billContentType?: string,
    detailedInvoice?: boolean,
    fileFormat?: string,
    otpCode?: string
  ): Promise<ExtendedAxiosResponse> =>
    apiClient.post(
      `${url}/ebill-file-download/info`,
      {
        billMonth: billMonth,
        billYear: billYear,
        caRefNoList: caRefNoList,
        fileFormat: fileFormat,
        contextCpRefNo: contextCpRefNo,
        detailedInvoice: detailedInvoice,
        billContentType: billContentType,
        otpCode: otpCode,
      },
      {
        params: {
          customerMasterSource: CustomerMasterSourceType.O2POP,
          channel: ChannelType.MO2_CARE,
        },
      }
    ),

  postEBillFileDownloadInitOtp: (url: string, caRefNoList: string[]): Promise<ExtendedAxiosResponse> =>
    apiClient.post(
      `${url}/ebill-file-download/init-otp`,
      { caRefNoList: caRefNoList },
      {
        params: {
          customerMasterSource: CustomerMasterSourceType.O2POP,
          channel: ChannelType.MO2_CARE,
        },
      }
    ),

  getFinancialDocumentReport: (
    url: string,
    caRefNoList: string,
    dateFrom: Date,
    cpRefNo?: string
  ): Promise<ExtendedAxiosResponse> =>
    apiClient.get(`${url}/financial-documents-report/file?caRefNoList=${caRefNoList}`, {
      params: {
        customerMasterSource: CustomerMasterSourceType.O2POP,
        channel: ChannelType.MO2_CARE,
        dateFrom: dateFrom,
        cpRefNo: cpRefNo,
      },
    }),
};
